import React, { Component } from 'react';
import { CustomCard } from "../../../../components/Card/CustomCard";
import { Timeline, Event } from "react-timeline-scribble";

class MisionVision extends Component {

    contenido = () => (
        <div id="misionVision">
            <Timeline>
                <Event interval="Misión">
                    <p className="fuente-monserrat" align="justify">
                        Formar profesionales de excelencia, en las especialidades de Diseño Interior, Diseño Gráfico, Publicidad y Mercadeo, Diseño de Moda y Diseño Textil, a través de programas educativos en permanente evolución, con habilidades y competencias esenciales para el mundo digital y globalizado de hoy, que correspondan a las necesidades del país y a los cambios que demanda; fomentando la investigación como vía para generar, aplicar y difundir nuevos conocimientos que favorezcan el avance tecnológico, humanístico y social; promoviendo actividades que propicien la integración social e interrelación entre la institución  y la comunidad, a objeto de elevar el nivel cultural y de favorecer el bienestar colectivo, contribuyendo así al enriquecimiento de la calidad de vida de la sociedad
                    </p>
                </Event>
                <Event interval="Visión">
                    <p className="fuente-monserrat" align="justify">
                        Ser una Institución de Educación Superior caracterizada por la excelencia, que contribuya al desarrollo económico, cultural, científico y tecnológico del país y a la convalidación de los valores fundamentales de la sociedad, enmarcados dentro del contexto nacional, latinoamericano y mundial; líder en formación académica; reconocida por la alta calificación de su talento humano; generadora y promotora de las nuevas tendencias de diseño, comunicación visual y vanguardia tecnológica; que promueva su cultura y la innovación creativa entre empresas, profesionales y usuarios, fortaleciendo las cadenas de valor en cada uno de los eslabones de la producción, solventando los retos de vinculación y extensión de la comunidad nacional e internacional, contribuyendo en la  educación intercultural y la construcción de un futuro sostenible.
                    </p>
                </Event>
            </Timeline>
        </div>
    )

    render() { 
        return (
            <CustomCard
                content={this.contenido()}
            /> 
        );
    }
}
 
export default MisionVision;


// WEBPACK FOOTER //
// ./src/site/Componentes/Institucion/Contenido/MisionVision.jsx